import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    FormControlLabel,
    IconButton,
    Switch,
    Tooltip,
    Typography,
} from '@mui/material';
import { GOODWAY_LIGHT, GOODWAY_YELLOW } from '../../constants/colors';

const TOOLTIP =
    'Auto-aliasing rewrites campaign names that follow the Goodway taxonomy into a shorter name on campaign_name_alias. Names that do not match the taxonomy stay unchanged. Aliases entered by hand still take priority. Turn this off to keep campaign_name_alias equal to the original campaign name unless an alias is set by hand.';

const AliasConfigurationAccordion = ({ autoAlias, onAutoAliasChange }) => {
    return (
        <Accordion
            sx={{
                backgroundColor: GOODWAY_LIGHT,
                paddingTop: 1,
                paddingBottom: 1,
                paddingLeft: 1,
                paddingRight: 1,
                marginTop: 3,
                marginBottom: 1,
                borderRadius: '10px',
                boxShadow: 'none',
            }}
        >
            <AccordionSummary
                expandIcon={
                    <ExpandMoreIcon sx={{ pointerEvents: 'auto', color: GOODWAY_YELLOW }} />
                }
            >
                <Typography
                    variant={'h5'}
                    style={{ color: '#fcd119', fontSize: 19, fontWeight: 300 }}
                >
                    Alias Configuration
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <FormControlLabel
                        sx={{ color: 'white', ml: 0 }}
                        control={
                            <Switch
                                checked={autoAlias !== false}
                                onChange={event => onAutoAliasChange(event.target.checked)}
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                        color: GOODWAY_YELLOW,
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                        backgroundColor: GOODWAY_YELLOW,
                                    },
                                }}
                            />
                        }
                        label={
                            <Typography
                                component='span'
                                sx={{ color: 'white', fontSize: 17, fontWeight: 300 }}
                            >
                                Auto-alias Campaign Names
                            </Typography>
                        }
                    />
                    <Tooltip title={TOOLTIP} arrow>
                        <IconButton size='small' sx={{ color: GOODWAY_YELLOW }}>
                            <InfoIcon fontSize='small' />
                        </IconButton>
                    </Tooltip>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};

export default AliasConfigurationAccordion;
